var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2299_1584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0953 25.9801H28.3078C25.7285 25.8227 24.1973 25.0043 22.8515 23.773C22.1505 23.1319 21.225 21.8777 20.544 20.8805L18.9832 18.1786L22.2872 12.4564C23.5066 10.3453 26.5543 10.3453 27.773 12.4564L32.8378 21.2291C34.0573 23.3409 32.5335 25.9801 30.0953 25.9801Z",
    fill: "#B63202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3078 25.9801H3.86409C1.47091 25.9801 -0.0255641 23.3889 1.17103 21.3163L8.29074 8.98551C9.48733 6.9129 12.4781 6.9129 13.6747 8.98551L18.9832 18.1786L20.544 20.8805C21.225 21.8777 22.1505 23.1319 22.8515 23.773C24.1973 25.0043 25.7285 25.8227 28.3078 25.9801Z",
    fill: "#FA4B16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1626 5.91205C12.8004 5.91205 14.1282 4.58429 14.1282 2.94642C14.1282 1.30855 12.8004 -0.0192032 11.1626 -0.0192032C9.52469 -0.0192032 8.19693 1.30855 8.19693 2.94642C8.19693 4.58429 9.52469 5.91205 11.1626 5.91205Z",
    fill: "#FA4B16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0305 9.3541C26.6683 9.3541 27.9961 8.02634 27.9961 6.38847C27.9961 4.7506 26.6683 3.42284 25.0305 3.42284C23.3926 3.42284 22.0648 4.7506 22.0648 6.38847C22.0648 8.02634 23.3926 9.3541 25.0305 9.3541Z",
    fill: "#B63202"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2299_1584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleLogo);
export default __webpack_public_path__ + "static/media/people_logo.c11b8af71715c7cefdbf54b474b93e06.svg";
export { ForwardRef as ReactComponent };